"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileDropZone = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var R = __importStar(require("../../utils/ramda"));
require("./FileDropZone.css");
var classnames_1 = __importDefault(require("classnames"));
var FileDropZone = function (_a) {
  var _b = _a.accept,
    accept = _b === void 0 ? "*" : _b,
    _c = _a.inline,
    inline = _c === void 0 ? false : _c,
    _d = _a.disabled,
    disabled = _d === void 0 ? false : _d,
    activeClassName = _a.activeClassName,
    className = _a.className,
    _e = _a.onDropFiles,
    onDropFiles = _e === void 0 ? R.N : _e,
    _f = _a.onRejectFile,
    onRejectFile = _f === void 0 ? R.N : _f,
    children = _a.children,
    restProps = __rest(_a, ["accept", "inline", "disabled", "activeClassName", "className", "onDropFiles", "onRejectFile", "children"]);
  var _g = __read((0, react_1.useState)(false), 2),
    active = _g[0],
    setActive = _g[1];
  (0, react_1.useEffect)(function () {
    if (disabled) {
      setActive(false);
    }
  }, [disabled]);
  var cn = (0, classnames_1.default)("vsx-file-drop-zone", inline && "vsx-file-drop-zone-inline", active && activeClassName, className);
  var onDrop = function (e) {
    if (disabled) return;
    e.preventDefault();
    var files = Array.from(e.dataTransfer.files);
    var acceptedFiles = files.filter(function (f) {
      return acceptFileWithCallback(f, accept, onRejectFile);
    });
    if (acceptedFiles.length) {
      onDropFiles(files);
    }
    setActive(false);
  };
  var onDragOver = function (e) {
    if (disabled) return;
    e.preventDefault();
    setActive(true);
  };
  var onDragLeave = function (e) {
    if (disabled) return;
    e.preventDefault();
    setActive(false);
  };
  return (0, jsx_runtime_1.jsx)("div", __assign({
    "data-active": active && !disabled,
    className: cn
  }, restProps, {
    onDrop: onDrop,
    onDragEnter: onDragOver,
    onDragOver: onDragOver,
    onDragLeave: onDragLeave
  }, {
    children: children
  }));
};
exports.FileDropZone = FileDropZone;
var acceptFileWithCallback = function (file, acceptedFiles, onRejectFile) {
  if (onRejectFile === void 0) {
    onRejectFile = R.N;
  }
  var result = acceptFile(file, acceptedFiles);
  if (!result) {
    onRejectFile(file);
  }
  return result;
};
var acceptFile = function (file, acceptedFiles) {
  if (file && acceptedFiles !== "*") {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
    var fileName_1 = file.name || "";
    var mimeType_1 = (file.type || "").toLowerCase();
    var baseMimeType_1 = mimeType_1.replace(/\/.*$/, "");
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();
      if (validType.charAt(0) === ".") {
        return fileName_1.toLowerCase().endsWith(validType);
      } else if (validType.endsWith("/*")) {
        // This is something like a image/* mime type
        return baseMimeType_1 === validType.replace(/\/.*$/, "");
      }
      return mimeType_1 === validType;
    });
  }
  return true;
};